<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit permission' : 'Add permission' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field"><span class="field-label">Permission name</span><input class="text-box-active" formControlName="permissionName" /></div>
      <div class="field"><span class="field-label">Label</span><input class="text-box-active" formControlName="permLabel" /></div>
    </div>
    <div class="field-row">
      <div class="field">
        <span class="field-label">Status</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="status">
            <mat-option [value]="1">Active</mat-option>
            <mat-option [value]="0">Inactive</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="field-row">
      <label class="checkbox-field">
        <input type="checkbox" formControlName="isDefaultPermission" />
        <span class="field-label">Default permission</span>
      </label>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ isEdit ? 'Save' : 'Add' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
